import {
	Alert,
	AlertIcon,
	Button,
	CircularProgress,
	Flex,
	Heading,
	Text,
} from '@chakra-ui/react';
import { authService } from 'api/services/authService';
import { ERROR } from 'constant/messages';
import { NAVIGATE } from 'constant/navigation';
import AuthCentered from 'layouts/auth/types/Centered';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const UnsubscribeEmail = () => {
	const [searchParams] = useSearchParams();
	const token = searchParams.get('token');
	const [status, setStatus] = useState('loading'); // loading, success, error
	const [errorMsg, setErrorMsg] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		const unsubscribe = async () => {
			try {
				const result = await authService.unsubscribeEmail(token);
				if (result.status === 200 && result.data.status === 'SUCCESS') {
					setStatus('success');
				} else {
					setStatus('error');
					setErrorMsg(ERROR.REQUEST_WRONG);
				}
			} catch (error) {
				setStatus('error');
				setErrorMsg(ERROR.REQUEST_WRONG);
			}
		};
		if (token) {
			unsubscribe();
		} else {
			setStatus('error');
			setErrorMsg(ERROR.LINK_WRONG);
		}
	}, [token]);

	return (
		<AuthCentered cardBottom='50px'>
			{status === 'loading' && (
				<Flex alignItems={'center'} direction={'column'}>
					<CircularProgress isIndeterminate color={'brand.500'} mb={4} />
					<Text>Estamos procesando tu solicitud...</Text>
				</Flex>
			)}
			{status === 'success' && (
				<Flex alignItems={'center'} direction={'column'}>
					<Heading size='lg' mb={10}>
						¡Te has dado de baja!
					</Heading>
					<Text textAlign={'center'} mb={10}>
						Ya no recibirás correos promocionales de Bumbei.
						<br />
						Si cambias de opinión, siempre serás bienvenido de vuelta.
					</Text>
					<Button
						mb={10}
						variant={'brand'}
						onClick={() => navigate(NAVIGATE.HOME)}
					>
						Volver a Bumbei
					</Button>
				</Flex>
			)}
			{status === 'error' && (
				<Flex alignItems={'center'} direction={'column'}>
					<Alert
						justifyContent={'center'}
						status='error'
						mb={4}
						borderRadius='md'
					>
						<AlertIcon />
						{errorMsg}
					</Alert>
					<Text mb={10}>
						Si crees que esto fue un error o necesitas ayuda, puedes
						escribirnos.
					</Text>
					<Button variant={'brand'} onClick={() => navigate(NAVIGATE.HOME)}>
						Ir a Bumbei
					</Button>
				</Flex>
			)}
		</AuthCentered>
	);
};

export default UnsubscribeEmail;
